const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

const menu = [
  {
    text: "Início",
    to: "/",
  },
  {
    text: "Sobre",
    to: "/sobre",
  },
  {
    text: "Serviços",
    to: "/servicos",
  },
  {
    text: "Legislação",
    to: "/legislacao",
  },
  {
    text: "Fale Conosco",
    to: "/fale-conosco",
  },
];

export { server, menu };
